import dayjs from 'dayjs';

export function getInitFinancialYear(fyEndMonth, referenceDate = dayjs()) {
    if (!fyEndMonth)
        return parseInt(referenceDate.format("YYYY"), 10);

    const lastDate = referenceDate.clone().month(fyEndMonth - 1).endOf('month');

    const dateEnd = lastDate.isBefore(referenceDate) ?
        lastDate.add(1, 'year') :
        lastDate;

    return parseInt(dateEnd.format("YYYY"), 10);
}
